module.exports = __webpack_public_path__ + "img/gartek-portfolio-transportation.91631bc5.jpeg";